import { quickFacts } from "@/mocks/movie";

export default function QuickFacts() {
  return (
    <section className="w-full bg-background-50 border-b border-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-8 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {quickFacts.map((fact) => (
            <div
              key={fact.label}
              className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5 flex flex-col gap-3"
            >
              <span className="w-10 h-10 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${fact.icon} text-xl`}></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500">{fact.label}</p>
                <p className="mt-1 text-sm md:text-base font-semibold text-foreground-950 leading-snug">
                  {fact.value}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}